import React from "react";
import { useTranslation } from "react-i18next";
import { FinancialSummary } from "./FinancialSummary";

export const CashOutTable = () => {
  const { t } = useTranslation();


  return (
    <div className="mx-auto bg-white p-6 rounded-lg shadow-lg">
      <h2 className="text-xl font-bold text-center mb-4">{t('cash_out_title')} - Billions Trade Club</h2>
      <p className="my-2">{t('cash_out_desc')}</p>
      <FinancialSummary />
    </div>
  );
};
